export enum InvestmentFilterType {
  All = 0,
  latestViewCount = 1,
  valuationAmount = 2,
  raisedPercentage = 3,
  investorCount = 4,
  //minimumPledgeAmount = 5
}
